export default "__VITE_ASSET__DnhapsGZ__"